export const INSIGHT_SK = 1;
export const INSIGHT_EN = 2;
export const IMAGES = 3;
